module.exports = __webpack_public_path__ + "img/info_new_camp.6c91bd1a.png";